'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EDSContext = require('../EDSContext/EDSContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var withPlatform = function withPlatform() {
    return function (WebComponent, MobileComponent) {
        var Wrap = _react2.default.forwardRef(function (props, ref) {
            var edsContext = props.edsContext,
                rest = _objectWithoutProperties(props, ['edsContext']);

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                edsContext.platform === 'mobile' && _react2.default.createElement(MobileComponent, rest),
                (!edsContext.platform || edsContext.platform === 'web') && _react2.default.createElement(WebComponent, rest)
            );
        });

        return (0, _EDSContext.withEDSContext)(Wrap);
    };
};

exports.default = withPlatform;